import { $ } from '../../utilities/selector'
import LoadManager, { QUEUE } from '../load-manager'

export default LoadManager.queue(() => {

  let els = $('.cms table');
  if ( !els ) return;

  function applyTableKeys(table) {
    let rows = [...table.querySelectorAll("tr")].map(el => [...el.querySelectorAll("td,th")]);
    let headings = rows.shift();
    rows.forEach(cells => {
      cells.forEach((cell, i) => {
        cell.setAttribute("data-key", headings[i].textContent);
      })
    });
  }

  [...els].forEach(applyTableKeys);

}, QUEUE.DOM);


// WEBPACK FOOTER //
// ./scripts/components/helpers/tables.js